import React from 'react';
import { Icon } from '@benzinga/core-ui';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight';
import styled from '@benzinga/themetron';
import Image from 'next/image';

export interface PlatformInfoProps {
  name: string;
  image?: string;
  affiliateLinkCompany?: string;
}

export const PlatformInfo: React.FC<PlatformInfoProps> = ({ affiliateLinkCompany, image, name }) => {
  return (
    <PlatformInfoWrapper className="platform-info-container">
      <div className="platform-info-wrapper">
        {image && (
          <a href={affiliateLinkCompany}>
            <Image
              alt={name}
              className="platform-logo"
              height={90}
              src={image}
              style={{ maxWidth: '100%', height: 'auto' }}
              width={200}
            />
          </a>
        )}
        <h2 className="listing-name">
          <a href={affiliateLinkCompany ?? '#'} rel="nofollow noreferrer" target="_blank">
            {name}
          </a>
        </h2>
      </div>
      {affiliateLinkCompany && (
        <a
          className="get-started-button"
          data-label="Offering Get Started"
          href={affiliateLinkCompany}
          rel="noopener noreferrer"
          target="_blank"
        >
          Get Started <Icon icon={faArrowRight} />
        </a>
      )}
    </PlatformInfoWrapper>
  );
};

export const PlatformInfoWrapper = styled.div`
  &.platform-info-container {
    background: #ffffff;
    margin-bottom: 1rem;
    border: 1px solid #ebebeb;
    border-radius: ${({ theme }) => theme.borderRadius.default};
    overflow: hidden;
    @media (max-width: 480px) {
      display: flex;
      flex-direction: column;
    }

    .platform-info-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 5px;
      padding: 1rem;
      width: 100%;
      .platform-logo {
        margin-bottom: 0.5rem;
      }
      .call-to-action-link {
        width: 100%;
        height: 45px;
        .link-icon {
          margin-right: 0.5rem;
          font-size: ${({ theme }) => theme.fontSize.lg};
        }
      }
    }
    .get-started-button {
      display: flex;
      background-color: ${({ theme }) => theme.colorPalette.blue500};
      padding: 10px;
      justify-content: space-between;
      align-items: center;
      color: #ffffff;
      font-weight: ${({ theme }) => theme.fontWeight.semibold};
      background-color: #fa8418;

      @media (min-width: 800px) {
        white-space: nowrap;
        gap: 0.5rem;
        width: 100%;
      }
      @media (max-width: 800px) {
        width: 30%;
      }
      @media (max-width: 480px) {
        width: 100%;
      }
    }
  }
`;
